import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingModule} from '../loading/loading.module';
import {BolivarDigitalButton} from './bolivar-digital-button.component';
import {BasicModalModule} from '../modals/basic-modal/basic-modal.module';
import { MultiCountryCurrencyModule } from '../../pipes/multi-country-currency/multi-country-currency.module';

@NgModule({
  declarations: [BolivarDigitalButton],
  imports: [
    CommonModule,
    LoadingModule,
    BasicModalModule,
    MultiCountryCurrencyModule,
  ],
  exports: [BolivarDigitalButton],
})
export class BolivarDigitalButtonModule { }